import { useEffect } from 'react';
import { isBrowser } from 'ws-scripts/modules/environment';
import { GALLERY_TABS } from '../constants/galleryTabs';

/**
 * Detects the `?openGallery=true` URL parameter on VDP page load.
 * When present, auto-opens the media gallery modal on the Image tab
 * starting at the 1st image (position 0).
 *
 * AC ref: US1908844
 */
const useOpenGalleryParam = ({
	onOpenModal,
	setCarouselIndex,
	setActiveTab,
	locationSearch = null
}) => {
	useEffect(() => {
		let search = locationSearch;
		if (search === null) {
			search = isBrowser ? window.location.search : '';
		}
		const params = new URLSearchParams(search);
		if (params.get('openGallery') === 'true') {
			setCarouselIndex(0);
			setActiveTab(GALLERY_TABS.PHOTOS);
			onOpenModal();
		}
		// Empty deps: run only on mount. onOpenModal/setCarouselIndex/setActiveTab
		// are stable references (useCallback/useState setters) — safe to omit.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
};

export default useOpenGalleryParam;
